






import { Component, Mixins } from "vue-property-decorator";
import Shared from "../common/shared";
import { UserModel } from "../models/UserModel";
import UserService from "../services/user.service";
import CompanyService from "../services/company.service";
import { CompanyModel } from "../models/CompanyModel";
import BaseServiceMixin from "../mixins/base.service.mixin";

@Component({})
export default class Callback extends Mixins(BaseServiceMixin) {
  protected userLoaded = false;
  protected user!: Oidc.User;
  protected userService!: UserService;
  protected companyService!: CompanyService;

  public async created() {
    this.userService = new UserService(this.axiosInstance);
    this.companyService = new CompanyService(this.axiosInstance);
  }

  private async mounted() {
    try {
      const user = await this.$oidc.handleRedirectCallback();

      this.$oidc.user = user;
      this.$oidc.profile = user.profile;
      this.$oidc.isLoggedIn = true;

      const userEmail = this.$oidc.GetUserEmail();
      localStorage.setItem(Shared.localStorageKeys.USER_EMAIL, userEmail);

      const inviteId = localStorage.getItem(Shared.localStorageKeys.INVITATION_ID);

      if (inviteId && inviteId !== "") {
        await this.userService.acceptInvite(inviteId);
        localStorage.removeItem(Shared.localStorageKeys.INVITATION_ID);
        this.goTo("/instructions");
        return;
      }

      const userDetail: UserModel | null = await this.userService.getProfile();
      this.vuexStore.setUser(userDetail);

      if (userDetail && userDetail.companyId) {
        const company: CompanyModel | null = await this.companyService.getCompanyDetails();
        this.vuexStore.setCompany(company);
      }

      const target = localStorage.getItem("target");
      localStorage.removeItem("target");
      if (target !== null) {
        this.goTo(target);
      } else {
        this.goTo("/");
      }
    } catch (err) {
      const wasForgotPassword = localStorage.getItem("forgotpassword");
      if (wasForgotPassword === "true") {
        const target = localStorage.getItem("target");
        localStorage.removeItem("target");
        localStorage.removeItem("forgotpassword");

        if (target !== null) {
          this.goTo(target);
        } else {
          this.goTo("/");
        }
      }
      this.$oidc.user = undefined;
      this.$oidc.profile = undefined;
      this.$oidc.isLoggedIn = false;

      if (err.response && err.response.status === 403) {
        this.goTo("/accessdenied");
        return;
      }

      if (err.response && err.response.status === 404) {
        this.goTo("/404");
        return;
      }

      if (err.error_description && err.error_description.indexOf("AADB2C90118") !== -1) {
        // detected the forgotten password code, so call the forgotten password route
        this.$oidc.forgotPassword();
      } else if (err.error_description && err.error_description.indexOf("AADB2C90091") !== -1) {
        // detected the cancel code for sign up, so redirect back to login screen
        this.goTo("/login");
      } else {
        this.goTo("/");
      }
    }
  }

  private goTo(path: string) {
    if (this.$router.currentRoute.name !== path) {
      this.$router.push(path).catch(() => {
        // Handle error
      });
    }
  }
}
